import { render, staticRenderFns } from "./ContentEdit.vue?vue&type=template&id=4bd069d4&scoped=true&"
import script from "./ContentEdit.vue?vue&type=script&lang=ts&"
export * from "./ContentEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ContentEdit.vue?vue&type=style&index=0&id=4bd069d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd069d4",
  null
  
)

export default component.exports